import useSWR from 'swr';

import { ENDPOINTS } from '@/api/endpoints';
import { getCountries } from '@/api/countries';

export function useCountriesOptions() {
  const { data: countries, isLoading } = useSWR(ENDPOINTS.COUNTRIES, () => getCountries());

  return { COUNTRIES: countries, isLoading };
}
